/**
 * The federated redirect URI, kept in a module of its own because
 * `auth0-adapter.tsx` has to recognise the path and must not pull the OIDC SDK
 * into the bundle to do it.
 */

/** Prefix of `/callback/:providerKey`. */
export const OIDC_CALLBACK_PATH_PREFIX = '/callback/';

/**
 * Builds the `redirect_uri` registered with a federated provider.
 *
 * @param {string} providerKey - Key of the `authProviders` entry
 * @returns {string} Absolute redirect URI on this origin
 */
export const buildOidcRedirectUri = (providerKey: string): string =>
  `${window.location.origin}${OIDC_CALLBACK_PATH_PREFIX}${encodeURIComponent(providerKey)}`;

/**
 * Whether a path is the federated callback route.
 *
 * @param {string} pathname - Path to test, e.g. `window.location.pathname`
 * @returns {boolean} true when a federated redirect is being completed
 */
export const isOidcCallbackPath = (pathname: string): boolean =>
  pathname.startsWith(OIDC_CALLBACK_PATH_PREFIX);
